import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100/50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-5/12">
            <span className="inline-block px-3 py-1 text-xs font-medium text-foreground-500 border border-background-300/70 rounded-full mb-5 tracking-wide">
              Understanding the System
            </span>

            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-2">
              What is
            </h2>
            <p className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-500 font-light italic mb-8">
              ACBuy Spreadsheet?
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              <strong>ACBuy Spreadsheet</strong> is a structured product comparison and tracking system
              that helps users analyze pricing, quality, and availability across multiple suppliers in
              one unified spreadsheet format. Rather than jumping between dozens of tabs and stores,
              the <strong>acbuyspreadsheet</strong> database centralizes everything into a single,
              easy-to-navigate interface.
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Since its launch, the system has grown to cover thousands of products across 14 distinct
              categories — from shoes and apparel to accessories and lifestyle goods — with data
              refreshed every 24 hours to ensure accuracy.
            </p>

            <Link
              to="/acbuyspreadsheet-guide"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
            >
              Read the full ACBuy Spreadsheet guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-7/12">
            <div className="flex items-center justify-end gap-10 md:gap-16 mb-8">
              <div className="text-right">
                <p className="font-heading text-4xl md:text-5xl font-bold text-primary-600">15K+</p>
                <p className="text-xs text-foreground-500 mt-1 tracking-wide">Products Tracked</p>
              </div>
              <div className="text-right">
                <p className="font-heading text-4xl md:text-5xl font-bold text-accent-600">14</p>
                <p className="text-xs text-foreground-500 mt-1 tracking-wide">Categories Covered</p>
              </div>
            </div>

            <div className="flex gap-4 items-start">
              <div className="w-[45%] h-64 rounded-xl overflow-hidden bg-background-200/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Dual%20monitor%20setup%20on%20a%20minimalist%20white%20desk%20showing%20product%20comparison%20charts%20and%20spreadsheet%20data%2C%20morning%20sunlight%20from%20large%20window%2C%20warm%20grey%20and%20natural%20wood%20tones%2C%20modern%20Scandinavian%20office%2C%20clean%20professional%20workspace%2C%20editorial%20tech%20photography&width=500&height=600&seq=about-v2-card-01&orientation=portrait"
                  alt="ACBuy Spreadsheet product comparison interface"
                  title="ACBuy Spreadsheet product comparison system"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="w-[55%] h-80 rounded-xl overflow-hidden bg-background-200/50 mt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Organized%20wardrobe%20shelf%20with%20folded%20clothing%20shoes%20and%20accessories%20in%20neutral%20earth%20tones%2C%20warm%20ambient%20lighting%20from%20above%2C%20boutique%20retail%20display%20aesthetic%2C%20wooden%20shelves%20against%20white%20wall%2C%20lifestyle%20product%20photography%2C%20orderly%20composition%20with%20natural%20textures&width=600&height=750&seq=about-v2-card-02&orientation=portrait"
                  alt="Products available through ACBuy Spreadsheet database"
                  title="Products tracked by ACBuy Spreadsheet"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}